import React, {useState} from "react";
import {locale} from "../../../../../common/consts";
import {Plus as AddIcon} from "react-feather"
import styles from "../style.module.css"
import Dropzone from 'react-dropzone';
import {Button, CircularProgress, FormControl, TextField, Typography} from "../../../../../common/components/libs";
import {observer} from "mobx-react";
import {useStores} from "../../../../../hooks";
import {
    changeCheckboxEventHandlerDecorator,
    changeEventHandlerDecorator,
    toFloat,
    toPenny
} from "../../../../../common/libs";
import {BookingFormType} from "../../../store/booking/forms";
import {uploadFile} from "../../../../../services/files";
import {
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    FormGroup,
    useMediaQuery,
    useTheme
} from "@material-ui/core";
import {SnackbarType} from "../../../../../stores/common";
import {useHistory} from "react-router-dom";
import {trackAddPosition} from "../../../../utils/MetrikaService";
import {
    BookingBadgeType,
    BookingScheduleSettingsType,
    MediaItems,
    MediaType
} from "../../../../../services/menu/models";
import ImageCropperForm, {ImageAspectRatio} from "../../../../../common/components/ImageCropperForm";
import {useTranslation} from "react-i18next";

export const defaultMediaItems: MediaItems = {
    preview: "",
    previewHighRes: "",
    regular: "",
    regularHighRes: "",
    source: "",
    sourceId: ""
};


const CreateBookingItemForm = () => {
    const { bookingStore, generalStore } = useStores();
    const currencyId = generalStore.currency.id;
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");

    const [currentFile, setCurrentFile] = useState<File | undefined>();
    const [price, setPrice] = useState("");
    const [amount, setAmount] = useState("");
    const [isRequestInProgress, setIsRequestInProgress] = useState(false);

    const [newBadgeChecked, setNewBadgeChecked] = useState<boolean>(false);
    const [profitableBadgeChecked, setProfitableBadgeChecked] = useState<boolean>(false);
    const [hitBadgeChecked, setHitBadgeChecked] = useState<boolean>(false);

    const [media, setMedia] = useState<MediaItems[]>([]);
    const [fileName, setFileName] = useState<string>("");
    const [isUploadInProgress, setIsUploadInProgress] = useState(false);
    const [isUploadPreviewInProgress, setIsUploadPreviewInProgress] = useState(false);
    const [isUploadRegularInProgress, setIsUploadRegularInProgress] = useState(false);
    const [isImagePreviewCropperVisible, setIsImagePreviewCropperVisible] = useState(false);
    const [isImageRegularCropperVisible, setIsImageRegularCropperVisible] = useState(false);
    const [sourceId, setSourceId] = useState("")
    const [mediaType, setMediaType] = useState<MediaType>(MediaType.source)
    const mediaLinks = defaultMediaItems;

    const {i18n, t} = useTranslation(["general", "menu", 'booking']);
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.up('sm'));

    const history = useHistory();

    if (!bookingStore.currentMenu) return null;
    if (bookingStore.currentMenu.menuCategories.length === 0) return null;
    if (bookingStore.selectedCategory === undefined) return null;

    const forms = bookingStore.forms;

    const closeForm = () => {
        forms.closeForm(BookingFormType.createBookingItem);
    };

    const checkSource = (str: string) => {
        return (str.includes(sourceId))
    }


    const handleSubmit = async () => {
        setIsRequestInProgress(true);
        bookingStore.resetBookingScheduleSettings();
        const categoryId = bookingStore.currentMenu.menuCategories[bookingStore.selectedCategory].id;
        const res = await bookingStore.createMenuItem({
            badges: {
                [BookingBadgeType.new]: {
                    isEnabled: newBadgeChecked,
                    type: BookingBadgeType.new
                },
                [BookingBadgeType.profitable]: {
                    isEnabled: profitableBadgeChecked,
                    type: BookingBadgeType.profitable
                },
                [BookingBadgeType.hit]: {
                    isEnabled: hitBadgeChecked,
                    type: BookingBadgeType.hit
                },
            },
            name: { [locale]: title },
            description: { [locale]: description },
            sortOrder: 0,
            isInStopList: false,
            menuBookingCategoryId: categoryId,
            menuItemModifierSets: [],
            sellPrice: {
                price: toPenny(toFloat(price)),
                currencyId: currencyId
            },
            media: media,
            amount: parseInt(amount),
            menuBookingItemSuggestions: [],
            bookingScheduleSettings: bookingStore.bookingScheduleSettings
        })
        if (res.err) {
            generalStore.showSnackbar({
                title: t("general:error"),
                description: t("menu:menuEditor.failedCreateMenu"),
                type: SnackbarType.error
            })

        } else {
            setIsRequestInProgress(false);
            generalStore.showSnackbar({
                title: t("menu:menuEditor.positionCreated"),
                type: SnackbarType.success
            });
            history.push(`/menus/booking/${bookingStore.currentMenu.id}/${categoryId}/${res.menuItemId}`);
            closeForm();
            trackAddPosition();

        }
    };

    const uploadImage = async (file: File) => {
        setIsUploadInProgress(true);

        try {
            const res = await uploadFile(file, MediaType.source);
            const { downloadUrl, sourceIdentifier } = res;
            setSourceId(sourceIdentifier);
            mediaLinks.source = downloadUrl;
            mediaLinks.preview = downloadUrl;
            mediaLinks.previewHighRes = downloadUrl;
            mediaLinks.regular = downloadUrl;
            mediaLinks.regularHighRes = downloadUrl;
        } catch (e) {
            generalStore.showSnackbar({
                title: t("general:error"),
                description: t("menu:menuEditor.failedLoadIMG"),
                type: SnackbarType.error
            })
        } finally {
            media[0] = mediaLinks;
            setMedia(media);
            setIsUploadInProgress(false);
        }
        return;
    };

    const customizeImage = async (file: File) => {
        try {
            if (!media[0]?.source) return;
            setFileName('');
            const res = await uploadFile(file, mediaType, sourceId);
            const { downloadUrl, highResDownloadUrl } = res;
            if (mediaType === MediaType.preview) {
                mediaLinks.preview = downloadUrl;
                mediaLinks.previewHighRes = highResDownloadUrl;
                setFileName(`${sourceId + '_preview.jpeg'}`)
            }
            if (mediaType === MediaType.regular) {
                mediaLinks.regular = downloadUrl;
                mediaLinks.regularHighRes = highResDownloadUrl;
                setFileName(`${sourceId + '_regular.jpeg'}`)
            }

            media[0] = mediaLinks;
        } catch (e) {
            generalStore.showSnackbar({
                title: t("general:error"),
                description: t("menu:menuEditor.failedLoadIMG"),
                type: SnackbarType.error
            })
        } finally {
            if (mediaType === MediaType.preview) setIsUploadPreviewInProgress(false);
            if (mediaType === MediaType.regular) setIsUploadRegularInProgress(false);
        }
        return;
    };


    const onDrop = async (files: File[]) => {
        setCurrentFile(files[0]);
        await uploadImage(files[0]);
    };

    let imageBlockContent = [];

    if (!isUploadInProgress && media.length === 0) {
        imageBlockContent.push(
            <Dropzone onDrop={onDrop} key="cmif_1s">
                {({ getRootProps, getInputProps }) => (
                    <div {...getRootProps({ className: styles.dropzone })}
                         style={{ minHeight: "200px", minWidth: "200px" }}>
                        <input {...getInputProps()} />
                        <AddIcon size={30}/>
                        <span>{t("general:load")}</span>
                    </div>
                )}
            </Dropzone>
        )
    } else if (isUploadInProgress) {
        imageBlockContent.push(
            <div
                key="cmif_3"
                style={{
                    minHeight: "200px",
                    minWidth: "200px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}
            >
                <CircularProgress
                    m={2}
                    color="secondary"
                />
            </div>
        )
    }
    if (media.length > 0) {
        imageBlockContent.push(
            <div className={styles.menuItemEditor} key="cmif_4">
                <img src={media[0].source} alt="" key={media[0].source} style={{maxWidth: 200, maxHeight: 200, objectFit: 'cover'}}/>
            </div>,
            <Dropzone onDrop={onDrop} key="cmif_5">
                {({getRootProps, getInputProps}) => (
                    <>
                        <div {...getRootProps()}
                             style={{textAlign: 'center'}}>
                            <input {...getInputProps()}  />
                            <Button color={"primary"}>{t("general:replace")}</Button>
                        </div>
                    </>
                )}
            </Dropzone>,
            <>
                { (mediaLinks.preview.length > 0 && checkSource(mediaLinks.preview))    &&
                    <div className={styles.menuItemEditor} key="cmif_4">
                        <img src={mediaLinks.preview}
                             alt=""
                             key={mediaLinks.preview}
                             className={styles.previewImage}
                        />
                    </div>
                }
                {!isUploadPreviewInProgress ?
                    <Button color={"primary"}
                            onClick={() => {
                                setMediaType(MediaType.preview);
                                setCurrentFile(currentFile);
                                setIsUploadPreviewInProgress(true);
                                setIsImagePreviewCropperVisible(true);
                            }}>
                        {t("menu:menuEditor.customizePreview")}</Button>
                    :
                    <CircularProgress
                        m={2}
                        color="secondary"
                    />
                }</>,
            <>
                { (mediaLinks.regular.length > 0 && checkSource(mediaLinks.regular)) &&
                    <div className={styles.menuItemEditor} key="cmif_4">
                        <img src={mediaLinks.regular}
                             alt=""
                             key={mediaLinks.regular}
							 className={styles.regularImage}


						/>
                    </div>
                }
                {!isUploadRegularInProgress ?
                    <Button color={"primary"}
                            onClick={() => {
                                setMediaType(MediaType.regular);
                                setCurrentFile(currentFile);
                                setIsUploadRegularInProgress(true);
                                setIsImageRegularCropperVisible(true);
                            }}>
                        {t("menu:menuEditor.customizeRegular")}</Button>
                    :
                    <CircularProgress
                        m={2}
                        color="secondary"
                    />
                }
            </>
        );
    }

    const form = bookingStore.forms.forms[BookingFormType.createBookingItem];


    return (
        <>
            <Dialog
                open={form.open}
                onClose={closeForm}
                aria-labelledby="form-dialog-title"
                fullWidth={true}
                maxWidth={"md"}
                fullScreen={!isSm}
            >
                <DialogTitle id="form-dialog-title">
                    {t("menu:menuEditor.addPosition")}
                </DialogTitle>
                <DialogContent>
                    <div style={{ display: "flex", flexDirection: isSm? "row": "column"}}>
                        <div className={styles.images}>
                            {imageBlockContent}
                        </div>
                        <div style={{ flexGrow: 1 }}>
                            <TextField
                                onChange={changeEventHandlerDecorator(setTitle)}
                                label={t("general:name")}
                                variant="outlined"
                                fullWidth
                                my={0}
                                value={title}
                            />
                            <FormControl fullWidth my={3} variant="outlined">
                                <TextField
                                    onChange={changeEventHandlerDecorator(setDescription)}
                                    label={t("general:description")}
                                    multiline={true}
                                    rows={4}
                                    rowsMax={4}
                                    variant="outlined"
                                    value={description}
                                />
                            </FormControl>
                            <FormControl fullWidth my={3} variant="outlined">
                                <TextField
                                    onChange={changeEventHandlerDecorator(setPrice)}
                                    label={t("menu:menuEditor.priceSale")}
                                    variant="outlined"
                                    value={price}
                                />
                            </FormControl>
                            <FormControl fullWidth my={3} variant="outlined">
                                <TextField
                                    onChange={changeEventHandlerDecorator(setAmount)}
                                    label={t("menu:menuEditor.amountAvailable")}
                                    variant="outlined"
                                    value={amount}
                                />
                            </FormControl>
                            <Typography variant={"h6"} mt={5} mb={2}>
                                {t("menu:menuEditor.specialPositionMark")}
                            </Typography>
                            <FormControl>
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={newBadgeChecked}
                                                onChange={changeCheckboxEventHandlerDecorator(setNewBadgeChecked)}
                                                value={newBadgeChecked}
                                            />
                                        }
                                        label={t("menu:badgeType.New")}
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={profitableBadgeChecked}
                                                onChange={changeCheckboxEventHandlerDecorator(setProfitableBadgeChecked)}
                                                value={profitableBadgeChecked}
                                            />
                                        }
                                        label={t("menu:badgeType.Profitable")}
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={hitBadgeChecked}
                                                onChange={changeCheckboxEventHandlerDecorator(setHitBadgeChecked)}
                                                value={hitBadgeChecked}
                                            />
                                        }
                                        label={t("menu:badgeType.Hit")}
                                    />
                                </FormGroup>
                            </FormControl>
                        </div>
                    </div>
                </DialogContent>

                <DialogActions style={{ paddingRight: 20, paddingBottom: 10 }}>
                    <Button
                        color="secondary"
                        mr={3}
                        onClick={() => {
                            closeForm()
                        }}
                    >
                        {t("general:cancel")}
                    </Button>
                    { isRequestInProgress ?
                        <Button
                            color="primary"
                            variant="contained"
                            disabled
                        >
                            <CircularProgress
                            size={25}
                            color="secondary"
                        />
                        </Button>  :

                        <Button
                            color="primary"
                            variant="contained"
                            onClick={handleSubmit}
                        >
                            {t("general:next")}
                        </Button>
                    }
                </DialogActions>
            </Dialog>
            <ImageCropperForm
                open={isImagePreviewCropperVisible}
                close={() => {
                    setIsImagePreviewCropperVisible(false);
                    setIsUploadPreviewInProgress(false)
                }}
                image={currentFile}
                uploadImage={customizeImage}
                aspectRation={ImageAspectRatio.rectangle_3_2}
                name={fileName}
            />
            <ImageCropperForm
                open={isImageRegularCropperVisible}
                close={() => {
                    setIsImageRegularCropperVisible(false);
                    setIsUploadPreviewInProgress(false)
                }}
                image={currentFile}
                uploadImage={customizeImage}
                aspectRation={ImageAspectRatio.rectangle_3_2}
                name={fileName}
            />
        </>
    );
};

export default observer(CreateBookingItemForm);
